"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isReference = void 0;
var superstruct_1 = require("superstruct");
var isStruct_1 = require("../utils/isStruct");
var ReferenceStruct = (0, superstruct_1.type)({
    /**
     * Firestore document ID - e.g. "foo"
     */
    id: (0, superstruct_1.string)(),
    /**
     * Path - e.g. "tasks/foo"
     */
    path: (0, superstruct_1.string)(),
    /**
     * Get Firebase document.
     */
    get: (0, superstruct_1.func)(),
});
function isReference(obj) {
    return (0, isStruct_1.isStruct)(obj, ReferenceStruct, "Reference");
}
exports.isReference = isReference;
